export default vm => ({
  generalData: {
    firstGeneralSection: [
      {
        text: vm.$t('fields.general.type'),
        value: 'circuitBreakerType',
        enumLabelPrefix: 'enums.asset-info.polarity.',
      },
      {
        text: vm.$t('fields.asset.circuit-breaker.installation-place'),
        value: 'circuitBreakerInstallationPlace',
        enumLabelPrefix: 'enums.asset-info.installation-place.',
      },
      {
        text: vm.$t('fields.asset.circuit-breaker.electric-arch-extinction-methods'),
        value: 'electricArchExtinctionMethod',
        enumLabelPrefix: 'enums.asset-info.electric-arch-extinction-methods.',
      },
      {
        text: vm.$t('fields.asset.circuit-breaker.nominal-tension'),
        value: 'circuitBreakerNominalTension',
        precision: 2,
      },
      {
        text: vm.$t('fields.asset.circuit-breaker.nominal-chain'),
        value: 'circuitBreakerNominalChain',
        precision: 2,
      },
      {
        text: vm.$t('fields.asset.circuit-breaker.nominal-frequency'),
        value: 'circuitBreakerNominalFrequency',
        precision: 0,
      },
      {
        text: vm.$t('fields.asset.circuit-breaker.opening-time'),
        value: 'typicalOpeningTime',
        precision: 0,
      },
      {
        text: vm.$t('fields.asset.circuit-breaker.closing-time'),
        value: 'maximumClosingTime',
        precision: 0,
      },
      {
        text: vm.$t('fields.asset.circuit-breaker.nominal-sequence-operation'),
        value: 'nominalOperationSequence',
      },
    ],
    interruptionCapability: [
      {
        text: vm.$t('fields.asset.circuit-breaker.nominal'),
        value: 'nominalInterruptionCapacity',
        precision: 2,
      },
      {
        text: vm.$t('fields.asset.circuit-breaker.continuous-chain'),
        value: 'continuousChainPercentage',
        precision: 1,
      },
    ],
    secondGeneralSection: [
      {
        text: vm.$t('fields.asset.circuit-breaker.operation-mechanism'),
        value: 'mechanismOperation',
        enumLabelPrefix: 'enums.asset-info.mechanism-operation-types.',
      },
      {
        text: vm.$t('fields.asset.circuit-breaker.short-duration-chain'),
        value: 'circuitBreakerSupportableShortChainDuration',
      },
    ],
    supportableNominalChain: [
      {
        text: vm.$t('fields.asset.circuit-breaker.applied-voltage'),
        value: 'circuitBreakerAppliedTension1Min',
        precision: 2,
      },
      {
        text: vm.$t('fields.asset.circuit-breaker.atmospheric-impulse'),
        value: 'circuitBreakerAtmosphericImpulse',
        precision: 0,
      },
      {
        text: vm.$t('fields.asset.circuit-breaker.industrial-frequency'),
        value: 'industrialFrequency',
        precision: 2,
      },
    ],
    thirdGeneralSection: [
      {
        text: vm.$t('fields.asset.maintenance-history'),
        value: 'circuitBreakerMaintenanceHistory',
      },
      {
        text: vm.$t('fields.general.observations'),
        value: 'circuitBreakerObservation',
      },
    ],
  },
});
